import {
  NG_VALIDATORS,
  UntypedFormControl,
  ValidatorFn,
  Validator
} from '@angular/forms';
import { Directive, Input, OnInit } from '@angular/core';
import { ValidateRulesService } from './validate-rules.service';

@Directive({
  selector: '[appRequiredElementValidator]',
  standalone: false,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: RequiredElementValidatorDirective,
      multi: true
    }
  ]
})
export class RequiredElementValidatorDirective implements Validator, OnInit {
  @Input() fieldName: string;
  @Input() minLength: number;
  @Input() maxLength: number;
  validator: ValidatorFn;

  constructor(private readonly _validate: ValidateRulesService) { }

  ngOnInit() {
    this.validator = this.requiredElementValidator(
      this.fieldName,
      this.minLength,
      this.maxLength
    );
  }
  validate(c: UntypedFormControl) {
    return this.validator(c);
  }

  requiredElementValidator(
    fieldName: string,
    minLength: number,
    maxLength: number
  ): ValidatorFn {
    return (c: UntypedFormControl) => {
      let errorMessage = '';
      let isValidFlag = false;
      const regExp = /^[a-zA-Z0-9 =+!#&%@,/_\[\]\-\.\(\)<>$]*$/;
      if (typeof c.value !== 'undefined' && c.value !== null) {
        if (c.value === '') {
          errorMessage = `${errorMessage + fieldName} is Mandatory`;
        } else if (!regExp.test(c.value)) {
          errorMessage =
            errorMessage +
            fieldName +
            ' is invalid (includes special characters: ' +
            c.value +
            ')';
        } else if (c.value.length < minLength || c.value.length > maxLength) {
          errorMessage =
            errorMessage +
            fieldName +
            ' field must be comprised of a minimum of ' +
            minLength +
            ' and a maximum of ' +
            maxLength +
            ' characters.';
        }
      } else {
        errorMessage = `${errorMessage + fieldName} is Mandatory`;
      }
      if (errorMessage === '') {
        isValidFlag = true;
      } else {
        //empty else condition
      }
      return {
        requiredElementValidator: {
          isValid: isValidFlag,
          error: errorMessage
        }
      };
    };
  }
}
